import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectField} from 'components';
import { TextField, Button, Grid2 } from '@mui/material';
import { getRequestList, updateRequestAction  } from '../actions/StepInActions';
import { enqueueSnackbar } from 'actions';

const UpdateRequestForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();
	const [requests, setRequests] = useState([]);
	const [requestName, setRequestName] = useState('');
	const [implementationDate, setImplementationDate] = useState('');
	const [implementationHours, setImplementationHours] = useState('');

	// Função para carregar os requests
	const loadRequestsList = async () => {
		try {
			const data = await getRequestList(); // Chama o endpoint para buscar requests
			setRequests(data); // Atualiza o estado com os dados mais recentes
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `Failed to get request list: ${error}`, options: { variant: 'error' } }));
		}
	};
	
	// Chamar a action diretamente no useEffect
	useEffect(() => {
		loadRequestsList();
	}, []);
		
	const handleSubmit = async () => {
		if (!requestName || !implementationDate || !implementationHours) {
			dispatch(enqueueSnackbar({ message: 'Please fill in all fields.', options: { variant: 'error' } }));
			return;
		}

		const formData = new FormData();
		formData.append('RequestName', requestName);
		formData.append('ImplementationDate', implementationDate);
		formData.append('ImplementationHours', implementationHours);
		formData.append('UserId', userId);

		try {
			await updateRequestAction(formData); // Chama a action para excluir
			dispatch(enqueueSnackbar({ message: `Updated request: ${requestName}`, options: { variant: 'success' } }));

			setImplementationDate(''); // Limpa a seleção
			setImplementationHours(''); // Limpa a seleção
			setRequestName(''); // Limpa a seleção

			await loadRequestsList(); // Recarrega a lista de requests após a exclusão
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `Failed to update request: ${error}`, options: { variant: 'error' } }));
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<SelectField
					id="inputRequest"
					name="inputRequest"
					value={requestName}
					onChange={(e) => setRequestName(e.target.value)}
					hintText="Select Request to Update"
					menuItems={requests.map((request) => ({
						value: request.name,
						text: request.name,
					}))} // Mapeia os resultados para `menuItems`
				/>
			</Grid2>
			<Grid2 item size={12}>
				<TextField
					label="Implementation Date"
					type="date"
					InputLabelProps={{ shrink: true }}
					variant="outlined"
					fullWidth
					value={implementationDate}
					onChange={(e) => setImplementationDate(e.target.value)}
				/>
			</Grid2>
			<Grid2 item size={12}>
				<TextField
					label="Implementation Hours"
					type="number"
					variant="outlined"
					fullWidth
					value={implementationHours}
					onChange={(e) => setImplementationHours(e.target.value)}
				/>
			</Grid2>
			<Grid2 item size={12}>
				<Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
					Update
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default UpdateRequestForm;
